import styled from 'styled-components';
export var Sparkline = styled.span.withConfig({
  displayName: "Sparkline",
  componentId: "sc-1a832ll-0"
})(["margin-right:3px;"]);